import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getCategory,
  getFiness,
  getModality,
  getZoneGeographique,
} from '../thunks/ForfaitThunk'

export interface ICategory {
  id: number
  code: string
  libelle: string
}

export interface FinessDto {
  id: number
  finess: string | null
  numero_lot: number | null
}

export interface Zone {
  code: string
  libelle: string
}

interface FTState {
  modalities: ICategory[]
  categories: ICategory[]
  zones: Zone[]
  finess: FinessDto[]
  loading: boolean
}

const initialState: FTState = {
  modalities: [],
  categories: [],
  zones: [],
  finess: [],
  loading: false,
}

const ftReducer = createSlice({
  name: 'ForfaitsTechnique',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getModality.pending, (state) => {
        state.loading = true
      })
      .addCase(
        getModality.fulfilled,
        (state, action: PayloadAction<ICategory[]>) => {
          state.modalities = action.payload
          state.loading = false
        },
      )
      .addCase(getModality.rejected, (state) => {
        state.loading = false
      })
      .addCase(getCategory.pending, (state) => {
        state.loading = true
      })
      .addCase(
        getCategory.fulfilled,
        (state, action: PayloadAction<ICategory[]>) => {
          state.categories = action.payload
          state.loading = false
        },
      )
      .addCase(getCategory.rejected, (state) => {
        state.loading = false
      })
      .addCase(getZoneGeographique.pending, (state) => {
        state.loading = true
      })
      .addCase(
        getZoneGeographique.fulfilled,
        (state, action: PayloadAction<Zone[]>) => {
          state.zones = action.payload
          state.loading = false
        },
      )
      .addCase(getZoneGeographique.rejected, (state) => {
        state.loading = false
      })
      .addCase(getFiness.pending, (state) => {
        state.loading = true
      })
      .addCase(getFiness.fulfilled, (state, action) => {
        state.finess = action.payload
        state.loading = false
      })
      .addCase(getFiness.rejected, (state) => {
        state.loading = false
      })
  },
})

export default ftReducer.reducer
